import React from 'react'
import './badge.css'

function Badge({ content }) {
  return (
    <div className={`badge badge-${content === 'completed' || content === 'confirmed' ? 'success' : 'warning'} `} >{content}</div>
  )
}

export default Badge